module.exports = __webpack_public_path__ + "eccc95ca24c04feaafdfb101526ce725.png";